export const departmentTrackingOfJobchart = (
  state = {
    jobchartFabrics: [],
    jobchartAccessories: [],
    jobchartStyles: [],
    fabricProcesses: {},
    styleProcesses: {},
    accessoryProcesses: {},
    rpoProcesses: [],
    fabricDepartmentFactories: { inventory: [] },
    accessoryDepartmentFactories: { inventory: [] },
    styleDepartmentFactories: { inventory: [] },
  },
  action
) => {
  if (action.type === 'FETCH_DEPARTMENT_TRACKING_OF_JOBCHART') {
    return action.payload;
  }

  if (action.type === 'CLEAR_DEPARTMENT_TRACKING_OF_JOBCHART') {
    return {
      jobchartFabrics: [],
      jobchartAccessories: [],
      jobchartStyles: [],
      fabricProcesses: {},
      styleProcesses: {},
      accessoryProcesses: {},
      rpoProcesses: [],
      fabricDepartmentFactories: { inventory: [] },
      accessoryDepartmentFactories: { inventory: [] },
      styleDepartmentFactories: { inventory: [] },
    };
  }

  return state;
};
export const oldDepartmentTrackingOfJobchart = (
  state = {
    jobchartFabrics: [],
    jobchartStyles: [],
  },
  action
) => {
  if (action.type === 'FETCH_OLD_DEPARTMENT_TRACKING_OF_JOBCHART') {
    return action.payload;
  }

  if (action.type === 'CLEAR_OLD_DEPARTMENT_TRACKING_OF_JOBCHART') {
    return {
      jobchartFabrics: [],
      jobchartStyles: [],
    };
  }

  return state;
};

export const currentDepartmentInfoForJobchart = (
  state = { fabrics: [], styles: [], accessories: [] },
  action
) => {
  if (action.type === 'FETCH_CURRENT_DEPARTMENT_INFO_FOR_JOBCHART') {
    return action.payload;
  }

  if (action.type === 'CLEAR_CURRENT_DEPARTMENT_INFO_FOR_JOBCHART') {
    return { fabrics: [], styles: [], accessories: [] };
  }

  return state;
};

export const issueChallans = (state = [], action) => {
  if (action.type === 'FETCH_ISSUE_CHALLANS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_ISSUE_CHALLANS') {
    return [];
  }

  return state;
};

export const issuedItemsOfJobchart = (
  state = { fabrics: [], styles: [], accessories: [] },
  action
) => {
  if (action.type === 'FETCH_ISSUED_ITEMS_OF_JOBCHART') {
    return action.payload;
  }

  if (action.type === 'CLEAR_ISSUED_ITEMS_OF_JOBCHART') {
    return { fabrics: [], styles: [], accessories: [] };
  }

  return state;
};
